export type LayoutSectionProps = {
  children: any
}

export function LayoutSection({ children }: LayoutSectionProps) {
  return <div>{children}</div>
}
